import { NumberInput as MantineNumberInput, NumberInputProps } from "@mantine/core";
import clsx from "clsx";
import isNumber from "lodash/isNumber";
import { forwardRef, Fragment, Ref } from "react";

import { selectInputOnFocus } from "#shared/helpers/selectInputOnFocus";
import { Flex } from "#shared/view/components/Flex";
import { Label } from "#shared/view/components/Label";
import { unitMap, UnitName } from "#shared/view/designSystem/inputs/units";

import classes from "./InputStyles.module.css";

export const NumberInput = forwardRef(
  (
    props: Omit<NumberInputProps, "onChange"> & {
      helper?: string;
      unit?: UnitName;
      onClickWhy?: () => void;
      inlineLabel?: boolean;
      small?: boolean;
      highlight?: boolean;
      onChange?: (value: number) => void;
    },
    ref: Ref<HTMLInputElement> | undefined,
  ) => {
    const { label, required, helper, unit, highlight, onClickWhy, onChange, small, ...rest } =
      props;

    const Container = props.inlineLabel ? Flex : Fragment;
    const containerProps = props.inlineLabel ? { gap: "xs" } : {};

    return (
      <Container {...containerProps}>
        {props.inlineLabel && (
          <Label
            required={required}
            helper={helper}
            onClickWhy={onClickWhy}
            classNames={{
              label: classes.label,
            }}
          >
            {label}
          </Label>
        )}
        <MantineNumberInput
          ref={ref}
          classNames={{
            input: clsx([
              small ? classes.smallInput : classes.input,
              highlight && classes.highlight,
            ]),
          }}
          hideControls={true}
          onFocus={selectInputOnFocus}
          onChange={(value) => {
            const valueNumber = Number(value);
            if (onChange && isNumber(valueNumber)) {
              onChange(valueNumber);
            }
          }}
          suffix={unit ? ` ${unitMap[unit]}` : undefined}
          placeholder={unit ? `en ${unitMap[unit]}` : undefined}
          decimalSeparator=","
          label={
            props.label &&
            !props.inlineLabel && (
              <Label
                required={required}
                helper={helper}
                onClickWhy={onClickWhy}
                classNames={{
                  label: classes.label,
                }}
              >
                {label}
              </Label>
            )
          }
          {...rest}
        />
      </Container>
    );
  },
);
